import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AdditionalDataSaveModel } from '../../../../../../vessel-visit/vessel-visit-list/models/PcdDocumentAndApprovalModels/AdditionalDataSaveModel';

@Component({
    selector: 'app-additional-data-input',
    templateUrl: './additional-data-input.component.html',
    styleUrls: ['./additional-data-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdditionalDataInputComponent implements OnInit {
    constructor() {}

    @Input()
    name: string;

    @Input()
    mandatory = false;

    @Input()
    disabled = true;

    @Input()
    dataType: string;

    @Input()
    dataFormat: string;

    @Input()
    defaultValue: any;

    @Input()
    dataId: number;

    value: any;

    @Input()
    longDisplay = false;

    isTextExpanded = false;
    isEmpty = true; // New property to track if the input is empty or not

    ngOnInit(): void {
        if (this.dataType === 'Checkbox' && this.defaultValue == null) {
            this.defaultValue = false;
        }
        this.value = this.defaultValue;
        this.isEmpty = this.isInputEmpty();
    }

    public resetToInitialData() {
        if (this.defaultValue instanceof Date && this.value instanceof Date) {
            this.defaultValue = new Date(this.defaultValue);
            this.value = new Date(this.defaultValue);
        } else {
            this.value = this.defaultValue;
        }
        this.isEmpty = this.isInputEmpty();
    }

    public numericValueChange($event) {
        this.value = $event;
        this.isEmpty = this.isInputEmpty();
    }

    public textValueChange($event) {
        this.value = $event.target.value;
        this.isEmpty = this.isInputEmpty();
    }

    public booleanValueChange($event) {
        this.value = $event.target.checked;
        this.isEmpty = this.isInputEmpty();
    }

    public getValue(): AdditionalDataSaveModel | null {
        if (
            (!(this.value instanceof Date) && this.value !== this.defaultValue) ||
            (this.value instanceof Date && this.value.getTime() !== this.defaultValue.getTime())
        ) {
            return {
                id: this.dataId,
                value: this.value.toString()
            };
        }
        return null;
    }

    public getRawValue(): AdditionalDataSaveModel {
        let val = null;
        if (this.value !== null) {
            val = this.value.toString();
        }
        return {
            id: this.dataId,
            value: val
        };
    }

    public updateDefaultValue() {
        if (this.defaultValue instanceof Date && this.value instanceof Date) {
            this.defaultValue = new Date(this.value);
        } else {
            this.defaultValue = this.value;
        }
    }

    public isMandatory() {
        return this.mandatory;
    }

    public getColumnWidth(): string {
        return this.longDisplay ? 'col-10' : 'col-2';
    }

    public clickedOnTextDiv(): void {
        if (this.disabled) {
            this.isTextExpanded = !this.isTextExpanded;
        }
    }

    public handleTextChange($event): void {
        const hasLineBreak = $event.target.innerText.includes('\n');
        if (hasLineBreak) {
            $event.target.innerText = $event.target.innerText.replace(/\n/g, ''); // Remove line breaks
        }
        this.value = $event.target.innerText.trim();
        this.isEmpty = this.value === '';
    }

    private isInputEmpty(): boolean {
        return (this.value === null || this.value === '') && this.isMandatory() && !this.disabled;
    }
}
